import { categories } from '@/mocks/gossip';

type Props = {
  activeCategory: string;
  keyword: string;
  sort: 'latest' | 'hot';
  onCategory: (slug: string) => void;
  onKeyword: (value: string) => void;
  onSort: (value: 'latest' | 'hot') => void;
};

export default function GossipToolbar({
  activeCategory,
  keyword,
  sort,
  onCategory,
  onKeyword,
  onSort,
}: Props) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-200 bg-background-50 px-4 py-2.5">
          <i className="ri-search-line text-lg text-foreground-400"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => onKeyword(e.target.value)}
            placeholder="搜索标题、标签或关键词"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          {keyword && (
            <button
              type="button"
              aria-label="清空搜索"
              onClick={() => onKeyword('')}
              className="flex h-6 w-6 items-center justify-center rounded-full text-foreground-400 transition-colors hover:bg-background-200"
            >
              <i className="ri-close-line"></i>
            </button>
          )}
        </div>

        <div className="flex items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          <button
            type="button"
            onClick={() => onSort('latest')}
            className={`flex-1 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors lg:flex-none ${
              sort === 'latest' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            最新发布
          </button>
          <button
            type="button"
            onClick={() => onSort('hot')}
            className={`flex-1 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors lg:flex-none ${
              sort === 'hot' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            最热吃瓜
          </button>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap gap-2 border-t border-background-200 pt-5">
        <button
          type="button"
          onClick={() => onCategory('all')}
          className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
            activeCategory === 'all'
              ? 'bg-foreground-950 text-background-50'
              : 'bg-background-50 text-foreground-600 hover:text-foreground-950'
          }`}
        >
          全部
        </button>
        {categories.map((category) => (
          <button
            key={category.slug}
            type="button"
            onClick={() => onCategory(category.slug)}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              activeCategory === category.slug
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-50 text-foreground-600 hover:text-foreground-950'
            }`}
          >
            <i className={category.icon}></i>
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}